import React, { useState, useEffect } from 'react';
import {
  Paper,
  TextField,
  InputAdornment,
  Button
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Search } from '@mui/icons-material';

const InventoryTable = ({ inventoryData, handleDelete, handleEdit }) => {
  const [search, setSearch] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (search.trim() === '') {
      setFilteredData(inventoryData);
    } else {
      const filtered = inventoryData.filter((inv) =>
        Object.values(inv)
          .join(' ')
          .toLowerCase()
          .includes(search.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [search, inventoryData]);

  const columns = [
    { field: 'variantName', headerName: 'Variant', flex: 1 },
    { field: 'warehouseName', headerName: 'Warehouse', flex: 1 },
    { field: 'inventoryStatusName', headerName: 'Status', flex: 1 },
    { field: 'batchNumber', headerName: 'Batch', flex: 1 },
    { field: 'locationBin', headerName: 'Location', flex: 1 },
    { field: 'expiryDate', headerName: 'Expiry', flex: 1 },
    { field: 'quantity', headerName: 'Qty', type: 'number', flex: 0.5 },
    { field: 'reorderLevel', headerName: 'Reorder', type: 'number', flex: 0.5 },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => handleDelete(params.row)}
            style={{ marginRight: 8 }}
          >
            Delete
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </Button>
        </>
      )
    }
  ];

  return (
    <Paper sx={{ padding: 2 }}>
      <TextField
        label="Search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          )
        }}
        sx={{ marginBottom: 2 }}
      />

      <DataGrid
        rows={filteredData}
        columns={columns}
        getRowId={(row) => row.inventoryId.warehouseId + ''+row.inventoryId.productVariantId +
          ''+ row.inventoryId.inventoryStatusId + ''+ row.inventoryId.batchNumber+ ''+  row.inventoryId.locationBin+ ''+  row.inventoryId.expiryDate }
        autoHeight
        pageSize={10}
        rowsPerPageOptions={[5, 10, 25]}
        pagination
      />
    </Paper> 
  );
};



export default InventoryTable;
